// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100vh;
  position: relative;
  /* Safari bounce effect 완전 제거 */
  overscroll-behavior: none;
  overscroll-behavior-y: none;
  overscroll-behavior-x: none;
  /* iOS Safari bounce 제거 */
  -webkit-overflow-scrolling: touch;
  /* 터치 이벤트 최적화 */
  touch-action: pan-y;
}

html, body {
  overscroll-behavior: none;
  overscroll-behavior-y: none;
  overscroll-behavior-x: none;
  height: 100%;
  overflow: visible;
  /* Safari bounce effect 제거 */
  -webkit-overflow-scrolling: touch;
  /* iOS Safari bounce 제거 */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}


@media (max-width: 768px) {
  .App {
    background-size: cover;
    background-position: center;
    /* 모바일 Safari bounce 완전 제거 */
    overscroll-behavior: none;
    overscroll-behavior-y: none;
    overscroll-behavior-x: none;
    -webkit-overflow-scrolling: touch;
    /* iOS Safari bounce 제거 */
    position: relative;
    overflow: hidden;
  }
  
  html, body {
    /* 모바일에서 bounce 효과 완전 제거 */
    overscroll-behavior: none;
    overscroll-behavior-y: none;
    overscroll-behavior-x: none;
    -webkit-overflow-scrolling: touch;
    /* iOS Safari bounce 제거 */
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    /* 터치 이벤트 제어 */
    touch-action: pan-y;
  }
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* BGM 슬라이더 스타일 */
.slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #3b82f6;
  cursor: pointer;
  border: none;
}

.slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #3b82f6;
  cursor: pointer;
  border: none;
}

.slider:focus {
  outline: none;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EAIzB,iBAAiB;AACnB;;;AAGA;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;IACjC,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".App {\r\n  text-align: center;\r\n  min-height: 100vh;\r\n  position: relative;\r\n  /* Safari bounce effect 완전 제거 */\r\n  overscroll-behavior: none;\r\n  overscroll-behavior-y: none;\r\n  overscroll-behavior-x: none;\r\n  /* iOS Safari bounce 제거 */\r\n  -webkit-overflow-scrolling: touch;\r\n  /* 터치 이벤트 최적화 */\r\n  touch-action: pan-y;\r\n}\r\n\r\nhtml, body {\r\n  overscroll-behavior: none;\r\n  overscroll-behavior-y: none;\r\n  overscroll-behavior-x: none;\r\n  height: 100%;\r\n  overflow: visible;\r\n  /* Safari bounce effect 제거 */\r\n  -webkit-overflow-scrolling: touch;\r\n  /* iOS Safari bounce 제거 */\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .App {\r\n    background-size: cover;\r\n    background-position: center;\r\n    /* 모바일 Safari bounce 완전 제거 */\r\n    overscroll-behavior: none;\r\n    overscroll-behavior-y: none;\r\n    overscroll-behavior-x: none;\r\n    -webkit-overflow-scrolling: touch;\r\n    /* iOS Safari bounce 제거 */\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  html, body {\r\n    /* 모바일에서 bounce 효과 완전 제거 */\r\n    overscroll-behavior: none;\r\n    overscroll-behavior-y: none;\r\n    overscroll-behavior-x: none;\r\n    -webkit-overflow-scrolling: touch;\r\n    /* iOS Safari bounce 제거 */\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    user-select: none;\r\n    /* 터치 이벤트 제어 */\r\n    touch-action: pan-y;\r\n  }\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* BGM 슬라이더 스타일 */\r\n.slider::-webkit-slider-thumb {\r\n  appearance: none;\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50%;\r\n  background: #3b82f6;\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\n.slider::-moz-range-thumb {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50%;\r\n  background: #3b82f6;\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\n.slider:focus {\r\n  outline: none;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
